import React, { useEffect, useState, useRef, memo } from 'react';
import { Clock } from 'lucide-react';
export const CountdownTimer = memo(function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 14,
    seconds: 42
  });
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  useEffect(() => {
    // Defer timer start by 2s to reduce TBT during initial load
    const startDelay = setTimeout(() => {
      timerRef.current = setInterval(() => {
        setTimeLeft(prev => {
          if (prev.seconds > 0) {
            return {
              ...prev,
              seconds: prev.seconds - 1
            };
          }
          if (prev.minutes > 0) {
            return {
              ...prev,
              minutes: prev.minutes - 1,
              seconds: 59
            };
          }
          if (prev.hours > 0) {
            return {
              ...prev,
              hours: prev.hours - 1,
              minutes: 59,
              seconds: 59
            };
          }
          return prev;
        });
      }, 1000);
    }, 2000);
    return () => {
      clearTimeout(startDelay);
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);
  const f = (val: number) => val.toString().padStart(2, '0');
  return <div className="bg-[#cc0000] text-white text-center py-3 px-4 font-bold text-sm md:text-base sticky top-0 z-40 shadow-md" data-id="element-1">
      <div className="flex items-center justify-center gap-2" data-id="element-2">
        <Clock className="w-5 h-5" aria-hidden="true" data-id="element-3" />
        <span data-id="element-4">
          OFERTA EXPIRA EN: {f(timeLeft.hours)}:{f(timeLeft.minutes)}:
          {f(timeLeft.seconds)} | SOLO QUEDAN 5 CUPOS
        </span>
      </div>
    </div>;
});